import Css from "./style.module.scss";

import Money from "utils/Money";
import React, { useCallback, useEffect, useRef } from "react";
import TransactionTypes from "const/TransactionTypes";
import classNames from "classnames";

const TransactionAmount = ({ type, amount, currency, className }) => {
  const ref = useRef(null);

  const withdrawTransaction = type === TransactionTypes.WITHDRAW;

  const content = Money.toMoneyString(amount || 0, currency);

  const handleCopy = useCallback((event) => {
    event.clipboardData.setData("text/plain", amount);
    event.preventDefault();
  }, [amount]);

  useEffect(() => {
    const { current } = ref;

    current.addEventListener("copy", handleCopy);

    return () => {
      current.removeEventListener("copy", handleCopy);
    };
  }, [handleCopy]);

  return (
    <div
      ref={ref}
      title={content}
      className={classNames(
        Css.transactionAmount,
        type && (withdrawTransaction ? Css.negative : Css.positive),
        className
      )}>
      {content}
    </div>
  );
};

export default React.memo(TransactionAmount);
